import { createRoot, hydrateRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import App from "./App.tsx";
import "./index.css";

const container = document.getElementById("root")!;
const app = (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <App />
  </ThemeProvider>
);

// Only hydrate when build-time prerendering injected a marker attribute
if (container.hasAttribute("data-prerendered")) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
